export default __webpack_public_path__ + "static/media/exit.485e2459.png";